export const getInitialValues = (workingHours, selectedYear) => {
  const selectedWorkingHours = workingHours?.find(item => item.year === selectedYear);

  return {
    year: selectedYear,
    notes: selectedWorkingHours?.notes ?? '',
    additionalNotes: selectedWorkingHours?.additionalNotes ?? '',
  };
};
